import { useMemo } from "react";
import type { ScopeFilters, ScopeOptions } from "@/types/filters";
import type { SchedulingRow } from "@/types/scheduling";
import { buildScopeOptions } from "@/lib/scopeOptions";

export function useScopeOptions(rows: SchedulingRow[], scope: ScopeFilters): ScopeOptions {
  return useMemo<ScopeOptions>(() => buildScopeOptions(rows, scope), [rows, scope]);
}
